/* eslint-disable */

/* CSS */

import './app.postcss';
import '@smatch/cassiopeia-web-components/dist/output.css';

/* I18N */

import { register, init, locale } from 'svelte-i18n';

register('en', () => import('./i18n/en.json'));

init({
    fallbackLocale: 'en',
    initialLocale: 'en',
});

locale.set('en');

/* APP */

import App from './App.svelte';

const TARGET: HTMLElement | null = document.getElementById('s8-app');

if (TARGET === null) {
    throw new Error('Could not find element with id="s8-app"');
}

const APP = new App({ target: TARGET });